// work data

export const Work = [
    {
      "id": 1,
      "name": "Node.js Backend Course - Coderhouse",
      "description": "Assistant tutor for a Node.js backend programming course, conducting classes, addressing student queries, and evaluating final projects.",
      "tags": ["Node.js", "MongoDB", "React", "Angular", "GitHub Actions", "GitHub Pages"],
      "demo": "https://www.coderhouse.com/ar/",
    },
    {
      "id": 2,
      "name": "Gaming Back Office - Trick Studios",
      "description": "Developing and enhancing features for a gaming project using .NET 6 and Blazor, focusing on the back office of the game.",
      "tags": [".Net 6", ".Net Core 3.1", "Blazor", "SQL Server", "Azure", "GitHub Actions"],
      "demo": "https://www.trickgs.com/",
    },
    {
      "id": 3,
      "name": "Financial Platform - Coelsa",
      "description": "Led the development of financial products in the Debin team, contributing to system analysis and supporting other developers.",
      "tags": [".Net 6", ".Net Core 3.1", "Angular v12", "SQL Server", "Azure"],
      "demo": "https://www.coelsa.com.ar/",
    },
    {
      "id": 4,
      "name": "Supervielle Insurance Platform",
      "description": "Technical leader for the insurance team at Banco Supervielle, overseeing project implementations and architectural decisions.",
      "tags": [".Net 6", ".Net Core 3.1", "Angular v12", "SQL Server", "Azure", "Kibana"],
      "demo": "https://www.supervielle.com.ar/personas",
    },
    {
      "id": 5,
      "name": "Azure Cloud Systems - Arroyo Consulting",
      "description": "Developed cloud-based systems using Azure, ensuring efficient deliveries through Scrum methodology, clean architecture, and unit testing.",
      "tags": [".Net Core", "React", "SQL", "Azure", "Scrum"],
      "demo": "https://arroyoconsulting.net/",
    },
    {
      "id": 6,
      "name": "Universal Music Group Tool - DXC Technology",
      "description": "Led development and maintenance of a universal tool using .NET MVC and WPF, supporting cloud implementations in AWS and Azure.",
      "tags": [".Net MVC", "WPF", "SQL Server", "JavaScript", "jQuery", "AWS", "Azure"],
      "demo": "https://dxc.com/ar/es",
    },
    {
      "id": 7,
      "name": "Banking Evolutionary Development - Accenture",
      "description": "Developed financial products using MVC, collaborating in agile teams under Scrum and leading production deployments.",
      "tags": ["React", "Razor", "HTML", "CSS", "SASS", "ASP.Net Core MVC", "ASP.Net Core Microservices", "Entity Framework 4.5", "Azure"],
      "demo": "https://www.accenture.com/ar-es",
    },
    {
      "id": 8,
      "name": "Construction Material Management System - Sys Box",
      "description": "Developed a purchasing management system for construction projects using .NET Core and React, hosted on Azure.",
      "tags": [".Net Core", "React", "SQL Server", "SQL Server Reporting Services", "Azure"],
      "demo": "https://www.sysbox.com.ar/",
    },
    {
      "id": 9,
      "name": "Transcore International Project",
      "description": "Developed and maintained web systems for North American use, fixing bugs and collaborating on architectural decisions.",
      "tags": [".Net Core", "SQL Server", "SQL Server Reporting Services", "Azure"],
      "demo": "https://sictranscore.com/",
    },
    {
      "id": 10,
      "name": "CRM System - EYNES EMPIS SRL",
      "description": "Developed and maintained a CRM system using Odoo, implementing customized billing applications and AWS integrations.",
      "tags": ["MySQL", "Python", "XML", "Odoo", "AWS"],
      "demo": "https://www.linkedin.com/company/eynes-odoo-argentina/?originalSubdomain=ar",
    },
    {
      "id": 11,
      "name": "Freelance Projects",
      "description": "Developed and maintained web applications for multiple clients, working on responsive designs, API integrations, and database optimizations.",
      "tags": ["React", ".Net", "SQL Server", "HTML", "CSS", "Bootstrap", "JavaScript", "Node.js", "MongoDB", "C#", "WordPress", "Azure"],
      "demo": "https://francososa.netlify.app",
    },
    {
      "id": 12,
      "name": "SMS Software - Kognito",
      "description": "Developed an AWS-based SMS software solution using serverless technology for efficient messaging services.",
      "tags": ["AWS", "Serverless", "Python", "Lambda", "DynamoDB"],
      "demo": "https://smslatam.com/",
    },
    {
      "id": 13,
      "name": "N5 Platform",
      "description": "Worked on a banking software solution enhancing digital transformation and financial services.",
      "tags": [".Net", "React", "Microservices", "Azure"],
      "demo": "https://n5now.com/es/",
    },
    {
      "id": 14,
      "name": "Andreani CFO Tech Project",
      "description": "Developed and optimized logistic and financial solutions for Andreani's CFO tech initiatives.",
      "tags": [".Net", "React", "SQL Server", "Azure"],
      "demo": "https://www.andreani.com/",
    },
    {
      "id": 15,
      "name": "Santander RH IT",
      "description": "Contributed to the HR IT department at Santander, enhancing internal software solutions for employee management.",
      "tags": [".Net", "Angular", "SQL Server", "Azure"],
      "demo": "https://www.santander.com/es/home",
    },
    {
      "id": 16,
      "name": "dynamic devs",
      "description": "Contributed to the dynamicdevs, enhancing internal software solutions for employee management.",
      "tags": [".Net", "Azure", "SQL Server", "Azure", "Postman"],
      "demo": "https://www.dynamicdevs.io/",
    }
  ]